var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { staticClass: "box d-print-none" }, [
        _c("div", { staticClass: "level" }, [
          _c("div", { staticClass: "level-left" }, [
            _vm.showChanger
              ? _c(
                  "div",
                  { staticClass: "level-item listing-selector" },
                  [
                    _c(
                      "b-select",
                      {
                        model: {
                          value: _vm.hospitalid,
                          callback: function ($$v) {
                            _vm.hospitalid = $$v
                          },
                          expression: "hospitalid",
                        },
                      },
                      _vm._l(_vm.hospitals, function (option) {
                        return _c("option", {
                          key: option.id,
                          domProps: {
                            value: option.id,
                            textContent: _vm._s(option.name),
                          },
                        })
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "level-right" },
            [_c("report-date-picker", { staticClass: "level-item" })],
            1
          ),
        ]),
      ]),
      _vm.layout
        ? _c("layout", {
            attrs: { page: _vm.layout, "hospital-id": _vm.hospitalid },
          })
        : _c(
            "div",
            [
              _vm.msg
                ? _c("h1", {
                    staticClass: "title",
                    domProps: { textContent: _vm._s(_vm.msg) },
                  })
                : _vm._e(),
              _c(
                "panel",
                { attrs: { heading: "Notifications" } },
                [
                  _c(
                    "b-notification",
                    { attrs: { type: "" } },
                    [
                      _c("h2", { staticClass: "subtitle" }, [
                        _vm._v("Welcome to DailyCare!"),
                      ]),
                      _c("br"),
                      _c(
                        "router-link",
                        {
                          staticClass: "button is-primary",
                          attrs: { to: "/organisations/listings" },
                        },
                        [_vm._v("View my listings")]
                      ),
                    ],
                    1
                  ),
                  _c("b-notification", { attrs: { type: "" } }, [
                    _c("h2", { staticClass: "subtitle" }, [
                      _vm._v("Logged in as a Super user"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }